import { useWebTranslation, Trans } from "translations";
import { MiniBanner } from "@/ui-kit";
import { objectToQueryString } from "utils/objectToQueryString";
import { getLiabilityStateFromState } from "components/Signup/flow/utils/bootstrapMultiPetSignup";
import { trackSignupEvent } from "components/Signup/analytics";
import { StepName } from "components/Signup/steps/types";
import { useSignupStore } from "components/Signup/store/hooks";

export const LiabilityBanner = () => {
  const { t } = useWebTranslation();
  const { getState } = useSignupStore();

  function onClick() {
    const state = getState();

    trackSignupEvent("LiabilityBanner banner clicked" as StepName, 0, state);

    const qs = objectToQueryString(getLiabilityStateFromState(state));

    window.location.href = `/signup?${qs}`;
  }

  return (
    <>
      <MiniBanner
        buttonText={t("liability_banner.button")}
        title={t("liability_banner.headline")}
        subTitle={t("liability_banner.subtitle")}
        description={
          <ul>
            <Trans
              i18nKey={"liability_banner.description"}
              components={[<li key="0" />, <li key="2" />]}
            />
          </ul>
        }
        onClick={onClick}
        imageUrl="/images/shields/liability.svg"
      />
    </>
  );
};
